// extracted by mini-css-extract-plugin
module.exports = {"testimonial":"Testimonial-module--testimonial--2UkuO","quote":"Testimonial-module--quote--127UQ","name":"Testimonial-module--name--1jBWz"};